import { ActionIcon, Tooltip } from '@mantine/core';
import React from 'react';

export const DisableableIconButtonWithTooltip= ({ disabled, tooltipText, icon, onClick, onAuxClick }: {
    disabled: boolean;
    tooltipText: string;
    icon: React.ReactElement;
    onClick?: () => void;
    onAuxClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}) => {
    const button = (
        <ActionIcon
            disabled={disabled}
            size={'sm'}
            onClick={onClick}
            onAuxClick={onAuxClick}
            style={{ padding: '6px', backgroundColor: 'inherit' }}
            variant={'transparent'}
            color={'var(--mantine-color-base-button)'}
        >
            {icon}
        </ActionIcon>
    );

    if (disabled) {
        return button;
    } else {
        return <Tooltip label={tooltipText}>{button}</Tooltip>;
    }
};


